import { useTokenPermissions } from "./useTokenPermissions";
import { TokenPermissionModule } from "../constants/permissions";

export function useRawTokenPermissions() {
  const { canView, canEdit, canAccess } = useTokenPermissions();

  const canViewRaw = (): boolean => {
    return canView(TokenPermissionModule.RAW);
  };

  const canEditRaw = (): boolean => {
    return canEdit(TokenPermissionModule.RAW);
  };

  const canAccessRaw = (): boolean => {
    return canAccess(TokenPermissionModule.RAW);
  };

  /**
   * Checks if the user has permission to view the raw dashboard listing.
   * The backend endpoint /v2/experience-raw-content requires "raw-dashboard-VIEW"
   * (distinct from "raw-VIEW" used for individual experience access).
   */
  const canViewRawDashboard = (): boolean => {
    return canView(TokenPermissionModule.RAW_DASHBOARD);
  };

  const canEditInternalRaw = (): boolean => {
    return canEdit(TokenPermissionModule.INTERNAL_RAW);
  };

  return {
    canViewRaw,
    canEditRaw,
    canAccessRaw,
    canViewRawDashboard,
    canEditInternalRaw,
  };
}
